const cache = {};
/**
 * @return {string} Formated string MM'
 * @param {number} s Milliseconds to convert
 */
export const parseTimeFromSeconds = (s) => {
    const toSeconds = s;
    if (!cache[toSeconds]) {
        const sec = toSeconds % 60;
        const min = Math.ceil((toSeconds - sec) / 60);
        cache[toSeconds] = min.toString();
    }
    return cache[toSeconds];
};
//# sourceMappingURL=parseTimeFromSeconds.js.map